module.exports = __webpack_public_path__ + "img/tpc-17.52286954.jpg";